import * as x from '../helpers/xmlHelpers';

export class Signatory {
	constructor(doc) {
		this.label = null;
		this.executionDate = null;
		var node;

		this.label = x.getStringAttribute(doc, "xlink:label");
		node = x.selectSingleNode(doc, "./ns:EXECUTION/ns:EXECUTION_DETAIL");
		this.executionDate = x.getMISMODateElement(node, "./ns:ExecutionDate");

	}
}

export class Signatories {
	constructor(doc) {
		this.signatoryList = [];
		var nodes;

		nodes = x.selectNodes(doc, "./ns:SIGNATORY");
		if (nodes.length > 0)
		{
				nodes.forEach((xn) => {
						this.signatoryList.push(new Signatory(xn));
				});
		}
	}

	GetSignatoryByLabel(label)	{
		for (let signatory of this.signatoryList) {
			if (signatory.label === label) {
				return signatory;
			}
		}
		return null;
	}

	GetSignatoryExecutionDate(label) {
		this.signatoryList.forEach(signatory => {
			if (signatory.label === label)	return signatory.executionDate;
		})
		return null;
	}
}
